import http from 'apis/config/http-service';
import { useCallback } from 'react';

// Restaurant search for the inquiry restaurant picker (ChakraAsyncSelect).
// Same call the ERP Mappings "Create Integration" modal uses: the `restaurants`
// list endpoint with the nestjs-crud `nameEn||$contL||<query>` filter.
const endpoint = 'restaurants';

export interface RestaurantOption {
  value: number; // restaurantId
  label: string;
}

export function useSearchRestaurantsApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: RestaurantOption[]) => void) => {
    http
      .get(endpoint, {
        params: {
          page: 1,
          limit: 20,
          filter: inputValue ? `nameEn||$contL||${inputValue}` : undefined,
        },
      })
      .then(({ data }) => {
        const list: Record<string, any>[] = data?.data ?? (Array.isArray(data) ? data : []);
        callback(list.map((r) => ({ value: r.id, label: r.name ?? r.nameEn ?? `Restaurant #${r.id}` })));
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
